<template>
  <b-nav-item-dropdown
    class="nav-item dropdown dropdown--profile"
    variant="none"
    toggle-class="text-decoration-none"
    no-caret
  >
    <template slot="button-content">
      <a
        id="navbarDropdown"
        href="#"
        :class="customNavLink"
        class="dropdown-toggle dropdown-toggle-profile"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <Avatar class="mr-2" size="sm" />
        {{ currentUser.name }}
      </a>
    </template>
    <b-dropdown-item
      v-for="route in this.routes"
      :key="route.link"
      class="dropdown-item"
      :to="route.link"
    >
      {{ route.label }}
    </b-dropdown-item>

    <b-dropdown-item class="dropdown-item" v-if="userIsReceptionist">
      <router-link to="/nurseschedule" style="color: black;">
        Marcar Consulta
      </router-link>
    </b-dropdown-item>

    <div class="dropdown-divider" />
    <b-dropdown-item class="dropdown-item" href="#" @click.prevent="sendLogout">
      Desconectar
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import ClickOutside from "vue-click-outside";
import { authMethods, userComputed, operatorMethods } from "./../state/helpers";
import { getRoutes } from "../utils/routes/routes.js";
import { isReceptionist } from "../utils/userRole";
import Avatar from "./Avatar";

export default {
  name: "ProfileDropdown",
  directives: {
    ClickOutside
  },
  components: {
    Avatar
  },
  props: { componentTag: { type: String, default: "" } },
  data() {
    return {
      active: false,
      routes: []
    };
  },
  mounted() {
    this.routes = getRoutes(this.userRole);
  },
  methods: {
    ...authMethods,
    ...operatorMethods,
    // photoFallback() {
    //   return (
    //     this.currentUser.photo || require("./../assets/images/doctor-img.jpg")
    //   );
    // },
    sendLogout() {
      if (this.userRole === "operator") {
        this.logoutOperator();
      } else this.logout();
    },
    showDropdown() {
      this.active = !this.active;
    },
    hideDropdown() {
      this.active = false;
    }
  },
  computed: {
    ...userComputed,
    userIsReceptionist() {
      return isReceptionist(this.currentUser);
    },
    userPhoto() {
      return `background-image: url(${this.photoFallback()});`;
    },
    customImgProfile() {
      return this.componentTag == "TopBar" ? "" : "custom--img-profile";
    },
    showDropdownClass() {
      return this.active ? "dropdown-menu visible" : "dropdown-menu";
    },
    customNavLink() {
      return this.componentTag == "TopBar" ? "nav-link" : "admin-nav-link";
    }
  }
};
</script>

<style scoped>
.visible {
  opacity: 1;
  display: inline-block;
}
.admin-nav-link {
  font-family: "Inter" sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #ffffff;
}
</style>
